/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertCompanyLogoEntryRequest
 */
export interface UpsertCompanyLogoEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertCompanyLogoEntryRequest
     */
    displayedCompanyName: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertCompanyLogoEntryRequest
     */
    logoUrl: string;
}

/**
 * Check if a given object implements the UpsertCompanyLogoEntryRequest interface.
 */
export function instanceOfUpsertCompanyLogoEntryRequest(value: object): value is UpsertCompanyLogoEntryRequest {
    if (!('displayedCompanyName' in value) || value['displayedCompanyName'] === undefined) return false;
    if (!('logoUrl' in value) || value['logoUrl'] === undefined) return false;
    return true;
}

export function UpsertCompanyLogoEntryRequestFromJSON(json: any): UpsertCompanyLogoEntryRequest {
    return UpsertCompanyLogoEntryRequestFromJSONTyped(json, false);
}

export function UpsertCompanyLogoEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertCompanyLogoEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'displayedCompanyName': json['displayedCompanyName'],
        'logoUrl': json['logoUrl'],
    };
}

export function UpsertCompanyLogoEntryRequestToJSON(value?: UpsertCompanyLogoEntryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'displayedCompanyName': value['displayedCompanyName'],
        'logoUrl': value['logoUrl'],
    };
}

